import React from 'react';
import PropTypes from 'prop-types';
import { gettext } from '@eventbrite/i18n';

import { formValidate } from '@eventbrite/eds-utils';
import { MailChunky } from '@eventbrite/eds-iconography';
import { ProgressIndicator } from '@eventbrite/eds-progress-indicator';

import EmailField from '../EmailField';
import FormSubmitButton from '../FormSubmitButton';
import PageHeader from '../PageHeader';

import ConnectedAuthNotification from '../../connectedComponents/AuthNotification';

import { emailValidate as validate } from '../utils';
import { FORGOT_PASSWORD_FORM } from '../../constants';

import './ForgotPasswordForm.scss';

const ForgotPasswordForm = ({
    autoFocus,
    handleSubmit,
    isSubmitOngoing,
    dataTestId,
}) => {
    let body = (
        <form
            onSubmit={handleSubmit}
            noValidate="novalidate"
            data-testid={`${dataTestId}-component`}
        >
            <div className="eds-l-pad-bot-6">
                <EmailField autoFocus={autoFocus} />
            </div>

            <div className="eds-l-pad-bot-8 eds-align--center">
                <FormSubmitButton
                    submitDisabled={isSubmitOngoing}
                    dataTestid={`${dataTestId}-submit`}
                    buttonCTA={gettext('Send')}
                    style="link"
                    __containerClassName="forgot-password-form__button--grey"
                />
            </div>
        </form>
    );

    if (isSubmitOngoing) {
        body = (
            <div
                className="eds-l-pad-bot-4 eds-align--center"
                data-testid={`${dataTestId}-loading`}
            >
                <ProgressIndicator
                    size="large-chunky"
                    shape="circular"
                    style="gradient"
                />
            </div>
        );
    }

    return (
        <div className="forgot-password-form eds-fx--fade-in eds-fx--delay-2">
            <PageHeader
                headerText={gettext('Reset your password')}
                iconType={<MailChunky />}
                subtitleText={gettext(
                    "Make sure we have the right address, and we'll send you an email with instructions to update your password.",
                )}
                iconColor="ui-700"
                bottomSpacing="eds-l-mar-bot-4"
            />

            <ConnectedAuthNotification />

            {body}
        </div>
    );
};

ForgotPasswordForm.propTypes = {
    handleSubmit: PropTypes.func,
    autoFocus: PropTypes.bool,
    isSubmitOngoing: PropTypes.bool,
    dataTestid: PropTypes.string,

    /* Props Provided Via ReduxForm */
    submitFailed: PropTypes.bool,
    submitSucceeded: PropTypes.bool,
    submitting: PropTypes.bool,
};

export default formValidate({
    validate,
    form: FORGOT_PASSWORD_FORM,
    touchOnBlur: false,
})(ForgotPasswordForm);
